<template>
    <div>
        <h2>Wachtwoord vergeten?</h2>
        <p class="mb-4">Geen zorgen. Het herstellen van uw wachtwoord is eenvoudig. Vertel ons gewoon het e-mailadres dat u gebruikt heeft om in te loggen.</p>
        <form @submit.prevent="submit">
            <div class="alert alert-success" role="alert" v-if="success">
                {{success}}
            </div>
            <div class="form-label-group">
                <input autocomplete="off" autofocus class="form-control"
                       data-vv-validate-on="blur"
                       id="inputEmail"
                       name="email"
                       placeholder="Email address"
                       type="text"
                       v-bind:class="[this.email.validated ? this.email.valid ? 'is-valid' : 'is-invalid' : '']"
                       v-model="form.email"
                       v-validate="'required|email'">
                <label for="inputEmail">E-mailadres</label>
                <div class="invalid-feedback">{{ errors.first('email') }}</div>
            </div>
            <button :disabled="loading"
                    class="btn btn-lg btn-primary btn-block btn-login text-uppercase font-weight-bold mb-2"
                    type="submit"><span v-if="!loading">Wachtwoord herstellen</span>
                <div v-else>
                                            <span aria-hidden="true" class="spinner-border spinner-border-sm"
                                                  role="status"></span>
                    Loading...
                </div>
            </button>
            <div class="text-center">
                <router-link :to="{name: 'login'}" class="small">Terug naar de login pagina</router-link>
            </div>
        </form>
    </div>
</template>
<script>
    import {mapFields} from 'vee-validate'

    export default {
        name: 'Forgot',
        data() {
            return {
                success: '',
                form: {
                    email: ''
                },
                loading: false
            }
        },
        computed: {
            ...mapFields(['email', 'password'])
        },
        methods: {
            submit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading = true
                        this.$store.dispatch('PASSWORD_FORGOT', {email: this.form.email})
                            .then((resp) => {
                                this.success = resp.data.message
                                this.form = {}
                                this.$validator.reset()
                                this.loading = false
                            })
                            .catch((error) => {
                                this.loading = false

                                if (error.error) {
                                    this.$validator.errors.add({
                                        field: 'email',
                                        msg: error.error
                                    })
                                    this.fieldsVee.email.valid = false
                                }
                            })
                    }
                })
            }
        }
    }
</script>
